import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";

/**
 * Polls GET /api/sellsy/health every 60s. Renders a thin red banner at the top
 * of the app whenever Sellsy's OAuth endpoint is down (HTTP != 200). Hidden
 * silently when Sellsy is healthy. Self-recovers without page reload.
 */
const SellsyStatusBanner = ({ apiUrl }) => {
  const [down, setDown] = useState(false);
  const [httpStatus, setHttpStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const res = await axios.get(`${apiUrl}/sellsy/health`, { withCredentials: false });
        if (cancelled) return;
        setDown(!res.data?.ok);
        setHttpStatus(res.data?.http_status ?? null);
      } catch (_) {
        if (cancelled) return;
        setDown(true);
        setHttpStatus(null);
      }
    };
    check();
    const id = setInterval(check, 60000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [apiUrl]);

  if (!down) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-50 bg-rose-600 text-white px-3 py-1.5 text-xs flex items-center justify-center gap-2 shadow-sm"
      data-testid="sellsy-status-banner"
    >
      <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />
      <span>
        Sellsy est temporairement indisponible{httpStatus ? ` (HTTP ${httpStatus})` : ""} —
        la création de contacts, sociétés, opportunités et devis est suspendue. Réessai automatique toutes les 60 s.
      </span>
    </div>
  );
};

export default SellsyStatusBanner;
